import React, {useState, useCallback} from 'react'
import './Quotes.scss'
import Button from '../Button/Button'
import {graphql} from 'gatsby'
import EmbedContainer from '../EmbedContainer/EmbedContainer'

const embed = `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/508454670?autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>`;

const Quotes = ({title, text, button, smallText, quotes}) => {
	const [active, setActive] = useState(false)

	const popupVideo = () => {
		setActive(true)
	}

	const embedVideo = useCallback(node => {
		if(node !== null) {
			node.querySelectorAll('.embed').forEach(a => {
				a.addEventListener('click', e => {
					e.preventDefault()
					popupVideo()
				})
			})
		}
	}, [])

	return(
		<div className="Quotes">
			{
				active && <EmbedContainer embed={embed} close={() => setActive(false)} />
			}
			{ title && <h1 className="heading-medium" dangerouslySetInnerHTML={{__html: title}} /> }
			{
				quotes &&
					<ul>
						{
							quotes.map((quote,i) =>
								<li key={i} dangerouslySetInnerHTML={{__html: quote.quote}} />
							)
						}
					</ul>
			}
			{ text && <div className="text" dangerouslySetInnerHTML={{__html: text}} /> }
			{ button && <Button {...button} /> }
			{ smallText && <p ref={embedVideo} className="smallText" dangerouslySetInnerHTML={{__html: smallText}} /> }
		</div>
	)
}

export const query = graphql`
	fragment Quotes on WpPage_Layout_block_Layout_Quotes {
		fieldGroupName
		title
		text
		button {
			target
			url
			title
		}
		smallText
		quotes {
			quote
		}
	}
`

export default Quotes